export default [
	{
		path: '/report/list',
		name: 'ReportList',
		component: () => import('@/views/report/list.vue'),
		meta: { title: '检测报告' }
	},
	{
		path: '/report/detail/:url',
		name: 'ReportDetail',
		component: () => import('@/views/report/detail.vue'),
		meta: { title: '报告详情' }
	},
	{
		path: '/report/view-report/:orderId',
		name: 'ViewReport',
		component: () => import('@/views/report/view-report.vue'),
		meta: { title: '报告详情' }
	}
]
